import {all, fork} from 'redux-saga/effects'
import registerSaga, {IDependencies as RegisterSagaDependencies} from './saga'
import * as model from './model'
import reducer from './reducer'

export default reducer
export * from './actions'

export {model}
export type ISagaDependencies =
  RegisterSagaDependencies
export function* saga(dependencies: ISagaDependencies) {
  yield all([
    fork<RegisterSagaDependencies>(registerSaga, dependencies),
  ])
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/register/index.ts